import { restRequest } from 'config/rest-client';

/**
 * @deprecated this function will be replaced wen all the pending screens are migrated.
 */
export const validateToken = async (token: string) => restRequest(`/v1/token_validation/${token}`);

export default {
  validateToken,
};
